module.exports = __webpack_public_path__ + "static/8-23054a2e1b6f29a9299644ee561603c0.png";